import { createApi } from '@reduxjs/toolkit/query/react';
import { config } from 'config';

import { defaultHeadersCommercialInsurance } from './defaultHeaders';
import { createCustomBaseQuery } from './utils/customBaseQuery';

interface AbnLookupResponse {
  abn: string;
  abnStatus: string;
  abnStatusEffectiveFrom: string;
  addressDate: string;
  addressPostcode: string;
  addressState: string;
  businessName: string[];
  entityName: string;
}

const customBaseQuery = createCustomBaseQuery({
  baseUrl: config.msCommercialInsApi,
  defaultHeaders: defaultHeadersCommercialInsurance,
  reducerPath: 'quotesApi',
  useRetry: true, // Enable retry for abn
});

export const abnApi = createApi({
  reducerPath: 'abnApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    abnLookup: builder.query<string | null, string>({
      query: (abn) => ({
        url: `/ref-data/abn-lookup/${abn}`,
        method: 'GET',
      }),
      transformResponse: (response: AbnLookupResponse) =>
        response.abnStatus === '' ? null : response.entityName,
    }),
  }),
});

export const { useLazyAbnLookupQuery } = abnApi;
